import type { SVGProps } from 'react';
const SvgSuccessToast = (props: SVGProps<SVGSVGElement>) => (

    <svg width="10" height="8" viewBox="0 0 10 8" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path d="M1.5 4.5L3.5 6.5L8.5 1.5" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);
export default SvgSuccessToast;